import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { ThermoboxFormView } from './thermobox-form-view';
import {
	getPartnersOptionsSelector,
	getIsPartnersLoadingSelector,
	getFormInitialValuesSelector,
} from '../../selectors';
import { THERMOBOX_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const ThermoboxFormWrapper = ({ partnersOptions, isPartnersLoading, isLoading }) => (
	<ThermoboxFormView partnersOptions={partnersOptions} isPartnersLoading={isPartnersLoading} isLoading={isLoading} />
);

const withForm = reduxForm({
	form: THERMOBOX_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(ThermoboxFormWrapper);

const mapStateToProps = createStructuredSelector({
	partnersOptions: getPartnersOptionsSelector(),
	isPartnersLoading: getIsPartnersLoadingSelector(),
	initialValues: getFormInitialValuesSelector(),
});

ThermoboxFormWrapper.propTypes = {
	partnersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isPartnersLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	initialValues: PropTypes.object,
};

const ThermoboxForm = connect(mapStateToProps)(withForm);

export { ThermoboxForm };
